const R = require('ramda');

/** @type {Dimension} */
class Dimension {
  constructor({ id, name, architecture, isCustom = true }) {
    this.id = id;
    this.name = name;
    this.architecture = architecture;
    this.isCustom = isCustom;
    this.dimensionElementById = {};
  }

  get dimensionElements() {
    return Object.values(this.dimensionElementById);
  }

  addDimensionElement(dimensionElement) {
    this.dimensionElementById[dimensionElement.id] = dimensionElement;
  }

  deleteDimensionElement(id) {
    delete this.dimensionElementById[id];
  }

  format() {
    const { id, name, isCustom } = this;
    const obj = {
      id,
      name,
      isCustom,
    };
    return obj;
  }
}

module.exports = Dimension;
